import { ICampaignType, IVariantType } from '../types';

export const TOOLTIP_CAMPAIGN_VARIANT: Record<ICampaignType, Record<IVariantType, string>> = {
  [ICampaignType.TEMPLATE]: {
    [IVariantType.VARIANT_A]:
      "This is the template you're currently using, and it will serve as the Control for your A/B testing. We'll use it as the baseline to compare against your test version.",
    [IVariantType.VARIANT_B]:
      'This is the version to test against the Control, called the Variant. Its link is managed by the Control version. When a visitor lands on a page in the Variant group, all following pages will stay in the same group.',
  },
  [ICampaignType.TEMPLATE_BUNDLE]: {
    [IVariantType.VARIANT_A]:
      "This is the template you're currently using, and it will serve as the Control for your A/B testing. We'll use it as the baseline to compare against your test version.",
    [IVariantType.VARIANT_B]:
      'This is the version to test against the Control, called the Variant. Its link is managed by the Control version. When a visitor lands on a page in the Variant group, all following pages will stay in the same group.',
  },
  [ICampaignType.PRICE]: {
    [IVariantType.VARIANT_A]:
      "This is the active product you're selling. Its current price becomes the Control.",
    [IVariantType.VARIANT_B]:
      'This is the unlisted product you duplicate from the Control to set tested price.',
  },
  [ICampaignType.URL]: {
    [IVariantType.VARIANT_A]:
      'Use this URL in your ads. Some visitors stay here, others are redirected to the Variant.',
    [IVariantType.VARIANT_B]: 'The destination URL for redirected visitors',
  },
};
